import {
  initializeUserCookiesPreference,
  setCookiesAcceptedByUser as setStateForCookiesAcceptedByUser
} from 'modules/cookies/slice'
import {searchContinued} from 'modules/sapiSearch/actions'
import {anchorReceived} from 'modules/sapiSearch/slice'
import saveUserSearchHistory from 'modules/search/actions/saveUserSearchHistory'
import {AnyAction} from 'redux'
import {
  isCookiesAcceptedByUser,
  setCookiesAcceptedByUser as setLocalStorageForCookiesAcceptedByUser
} from 'utils/persistence'

import {MiddlewareType} from '../middlewareList'

const middleware: MiddlewareType = store => next => action => {
  switch (action.type) {
    case initializeUserCookiesPreference.type: {
      const {dispatch} = store
      dispatch(setStateForCookiesAcceptedByUser(isCookiesAcceptedByUser()))
      break
    }

    case setStateForCookiesAcceptedByUser.type: {
      if (action.payload) {
        setLocalStorageForCookiesAcceptedByUser()
      }

      return next(action)
    }

    case searchContinued.type: {
      const result = next(action)
      store.dispatch(saveUserSearchHistory() as unknown as AnyAction)
      return result
    }
    case anchorReceived.type: {
      const result = next(action)
      if (typeof window !== 'undefined')
        store.dispatch(saveUserSearchHistory() as unknown as AnyAction)
      return result
    }
  }

  return next(action)
}

export default middleware
